import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('accordion-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            isAnimating: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {},

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleAccordion(e) {
            if (!e || this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const { target } = e;
            const parent = target.parentNode;
            const body = parent.querySelector('.image-accordion__item-body');
            const icon = parent.querySelector('.plus-icon-vertical');
            const status = parent.classList.contains('is-open');
            const tl = gsap.timeline();

            gsap.set(icon, {
                transformOrigin: 'center center',
            });

            if (status) {
                tl
                    .to(body, {
                        duration: 1,
                        height: 0,
                        ease: 'power4.out',
                    })
                    .to(icon, {
                        duration: 1,
                        rotate: '0deg',
                        ease: 'power4.out',
                        onComplete: () => {
                            parent.classList.remove('is-open');
                            this.isAnimating = false;
                        },
                    }, '<');
                return;
            }

            tl
                .to(body, {
                    duration: 1,
                    height: 'auto',
                    ease: 'power4.out',
                })
                .to(icon, {
                    duration: 1,
                    rotate: '90deg',
                    ease: 'power4.out',
                    onComplete: () => {
                        parent.classList.add('is-open');
                        this.isAnimating = false;
                    },
                }, '<');
        },
    },
});
